import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function gallerySlider() {
    var sliders = document.querySelectorAll('[data-element="gallery-slider"]')
    if(sliders) {
    sliders.forEach((slider) => {
      var swiper = new Swiper(slider, {
        modules: [ Navigation ],            
        slidesPerView: 1,    
        loop: true,
        spaceBetween: 20,
        centeredSlides: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          700: {
            centeredSlides: false,
            spaceBetween: 40,
          },
          828: {
            slidesPerView: 2,
            // centeredSlides: false,
          },
        }

    });
    })    
  }
    
}

export default gallerySlider;;